
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/access-angel-investor",
      function () {
        return require("private-next-pages/account/access-angel-investor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/access-angel-investor"])
      });
    }
  